// ./src/utils/assets.ts

// Helper to get base URL (handles both dev and prod)
const getAssetPath = (path: string): string => {
  // import.meta.env.BASE_URL is '/' by default, handles custom base paths
  return `${import.meta.env.BASE_URL}${path}`.replace('//', '/');
};

export const ASSETS = {
  LOGO: getAssetPath('assets/images/android-chrome-512x512.png'),
  // Favicons
  FAVICON_ICO: getAssetPath('assets/images/favicon.ico'),
  FAVICON_16: getAssetPath('assets/images/favicon-16x16.png'),
  FAVICON_32: getAssetPath('assets/images/favicon-32x32.png'),
  APPLE_TOUCH_ICON: getAssetPath('assets/images/apple-touch-icon.png'),
  // PWA Icons
  PWA_192: getAssetPath('assets/images/android-chrome-192x192.png'),
  PWA_512: getAssetPath('assets/images/android-chrome-512x512.png'),
} as const;

export type AssetKey = keyof typeof ASSETS;